(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["luminance-reviews-carousel"] && !Shopify.designMode) return;
  try {
    const OKENDO_CONFIG = {
    subscriberId: '0fe62271-3f7e-44ab-8890-5ac23a6c0c4a',
    productId: '9854521508183',
  };

  let swiper = null;

  function createReviewCard(review) {
    return `
      <div class="swiper-slide">
        <div class="review-card">
          <div class="review-image-wrapper">
            <img src="${review.image}" alt="Recensione" loading="lazy">
          </div>
          <div class="reviewer-header">
            <div class="reviewer-name">${review.name}</div>
            ${review.verified ? '<div class="verified-badge">Verified customer</div>' : ''}
          </div>
          <h3 class="review-title">${review.title}</h3>
          <div class="review-text">${review.text}</div>
        </div>
      </div>
    `;
  }

  function initSwiper(reviewsCount) {
    if (swiper) {
      swiper.destroy(true, true);
    }

    swiper = new Swiper('.reviewsSwiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      loop: false,
      slidesPerGroup: 1,
      pagination: {
        el: '.reviewspagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.reviewswiper-next',
        prevEl: '.reviewswiper-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 1,
          spaceBetween: 16,
          slidesPerGroup: 1,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 16,
          slidesPerGroup: 1,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
          slidesPerGroup: 1,
        },
      },
    });
  }

  async function loadReviews() {
    const reviewsContainer = document.getElementById('reviewsContainer');

    try {
      const url = `https://api.okendo.io/v1/stores/${OKENDO_CONFIG.subscriberId}/products/shopify-${OKENDO_CONFIG.productId}/reviews?limit=25`;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) return;

      const data = await response.json();

      if (!data.reviews || data.reviews.length === 0) return;

      const filteredReviews = data.reviews.filter((review) => {
        if (review.rating !== 5) return false;
        if (!review.media || review.media.length === 0) return false;

        return review.media.some(
          (media) => 
            media.type === 'image' || 
            media.type === 'photo' ||
            (media.mediaType && media.mediaType.toLowerCase() === 'image')
        );
      });

      if (filteredReviews.length === 0) return;

      const reviews = filteredReviews.map((review) => {
        const firstImage = review.media.find(
          (media) => 
            media.type === 'image' || 
            media.type === 'photo' ||
            (media.mediaType && media.mediaType.toLowerCase() === 'image')
        );

        const reviewText = review.body || '';
        const reviewTitle = review.title || reviewText.substring(0, 50);

        return {
          name: review.reviewer?.displayName || review.reviewer?.name || 'Cliente Verificato',
          title: reviewTitle,
          text: reviewText,
          image: firstImage.fullSizeUrl || firstImage.url || firstImage.mediaUrl,
          verified: review.reviewer?.isVerified || false,
        };
      });

      reviewsContainer.innerHTML = reviews.map((review) => createReviewCard(review)).join('');

      setTimeout(() => {
        initSwiper(reviews.length);
      }, 100);
    } catch (error) {
      return;
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadReviews);
  } else {
    loadReviews();
  }
  } catch(e) { console.error(e); }
})();

})();
